import script from "./InviteLinkPage.vue?vue&type=script&setup=true&lang=js"
export * from "./InviteLinkPage.vue?vue&type=script&setup=true&lang=js"

import "./InviteLinkPage.vue?vue&type=style&index=0&id=1b4ce5c9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b4ce5c9"]])

export default __exports__